import React from "react";
import { Card, Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";


const pillStyle = {
  background: "#f3f4f7",
  color: "#232c29",
  padding: "4px 10px",
  borderRadius: 12,
  fontSize: 13,
  fontWeight: 600,

};

const thStyle = {
  padding: "8px 12px",
  fontWeight: 600,
  borderBottom: "1px solid #e6e6eb",
};

const tdStyle = {
  padding: "8px 12px",
  borderBottom: "1px solid #f0f0f0",
  fontSize: 14,
};

const PreviewScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const record = location.state?.record || {};

  
  const stats = {
    totalMSPC: 149,
    totalProjects: 1490,
    totalCategory: 6,
    overallFG: "2900 T",
    subStats: [
      "Pushthi: 100 T (27.8%)",
      "MLC: 2.3 T (0.8%)",
      "MLM: 2.9 T (0.8%)",
      "UPC: 2.3 T (0.8%)",
      "UPM: 2.3 T (0.8%)",
      "ANM: 98 T (2.7%)",
      "KIT: 10 T (2.9%)",
    ],
    tableData: [
      ["KARWAR", "1.5 T", "2.3 T", "0.9 T", "1.8 T", "3.4 T", "1.1 T", "2.6 T", "30 T", "7%"],
      ["KARWAR", "1.4 T", "2.1 T", "1.7 T", "0.8 T", "2.5 T", "1.3 T", "1.9 T", "32 T", "6%"],
      ["KARWAR", "1.6 T", "2.0 T", "1.4 T", "1.0 T", "2.2 T", "1.5 T", "1.8 T", "29 T", "8%"],
      ["KARWAR", "1.3 T", "2.4 T", "1.6 T", "1.7 T", "1.1 T", "2.3 T", "1.5 T", "31 T", "9%"],
      ["KARWAR", "1.2 T", "2.1 T", "1.4 T", "1.9 T", "1.8 T", "2.0 T", "1.8 T", "33 T", "10%"],
      ["KARWAR", "1.5 T", "2.2 T", "1.6 T", "1.4 T", "1.7 T", "1.9 T", "2.1 T", "30 T", "11%"],
      ["", "20 T", "13 T", "55 T", "23 T", "12 T", "34 T", "45 T", "", ""],
    ],
  };
   
  const exportCSV = () => {
  const statsRows = [
    ["TOTAL MSPC", stats.totalMSPC],
    ["TOTAL Projects", stats.totalProjects],
    ["TOTAL Category", stats.totalCategory],
    ["Overall FG", stats.overallFG],
  ];
  stats.subStats.forEach((item) => {
    const [name, value] = item.split(":");
    statsRows.push([name.trim(), value.trim()]);
  });
 const headers = [ "MSPC", "Rice","Wheat","Jaggery","Dry Chilly","Sugar","Vitamin","BG Dhall","Overall Total","Total Share"
  ];
  const tableRows = stats.tableData.map((row) =>
    row.map((cell) => `"${cell || ""}"`).join(",")
  );
 let csvContent =
    "Stats Section\n" +
    statsRows.map((row) => row.join(",")).join("\n") +
    "\n\nTable Section\n" +
    [headers.join(","), ...tableRows].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Preview_Report_${record.fileId || "data"}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "32px 0" }}>
      <Card
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          borderRadius: 18,
          border: "none",
          boxShadow: "0 2px 8px #f0f1f2",
        }}
        bodyStyle={{ padding: "28px 38px" }}
      >
        {/* Header */}
        <div style={{ display: "flex",justifyContent:"space-evenly", alignItems: "flex-start", gap: 16, marginBottom: 24 }}>
          <span style={pillStyle}>File : <strong>{record.fileId || "KTKKAR0825"}</strong></span>
          <span style={pillStyle}>Month : <strong>{record.month || "June 2025"}</strong></span>
          <span style={pillStyle}>T.B: <strong>1245434</strong></span>
          <span style={{ marginLeft: "15",background: "#19a459", color: "#fff", fontWeight: 600, borderRadius: 10, padding: "6px 24px", fontSize: 15}}>READY TO SUBMIT</span>
          <Button onClick={exportCSV} style={{ display:"flex", justifyContent:"flex-end", marginLeft:"75"}}>Export</Button>
        </div>

        {/* Stats */}
        <div style={{ display: "flex", gap: 20, marginBottom: 30 }}>
          <Card style={{ flex: 1, borderRadius: 14 }}>
            <div style={{ fontSize: 18, color: "#000" }}>TOTAL MSPC</div>
            <div style={{ fontSize: 22, fontWeight: 400 ,color:"#0e70f2"}}>{stats.totalMSPC}</div>
          </Card>
          <Card style={{ flex: 1, borderRadius: 14 }}>
            <div style={{ fontSize: 18, color: "#000" }}>TOTAL Projects</div>
            <div style={{ fontSize: 22, fontWeight: 400 ,color:"#0e70f2"}}>{stats.totalProjects}</div>
          </Card>
          <Card style={{ flex: 1, borderRadius: 14 }}>
            <div style={{ fontSize: 18, color: "#000" }}>Total Category</div>
            <div style={{ fontSize: 22, fontWeight: 400 ,color:"#0e70f2"}}>{stats.totalCategory}</div>
          </Card>
          <Card style={{ flex: 1, borderRadius: 14 }}>
            <div style={{ fontSize: 18, color: "#000" }}>Overall FG</div>
            <div style={{ fontSize: 22, fontWeight: 400, color: "#0e70f2" }}>{stats.overallFG}</div>
          </Card>
        </div>
       <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 26 }}>
  {stats.subStats.map((label, idx) => {

    const [namePart, valuePart] = label.split(":");
    

    return (
      
      <div key={idx} style={pillStyle}>
        <span style={{ color: "#232c29" }}>{namePart}:</span>{" "}
        <span style={{ color: "#0e70f2", fontWeight: 600 }}>{valuePart}</span>
      </div>
    );
  })}
</div>
 {/* Validation + Changes */}
        <div style={{ display: "flex", gap: 30, marginBottom: 30 }}>
          <Card style={{ flex: 1, borderRadius: 12 }}>
            <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 10 }}>Validations Error</div>
            <div style={{ fontSize: 14, color: "#6b6b6b" }}>No Validation Errors Found in the Sheet</div>
          </Card>
          <Card style={{ flex: 1, borderRadius: 12 }}>
            <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 10 }}>Changes Made</div>
            <div style={{ fontSize: 14, color: "#6b6b6b" }}>Data Are changed in Manual</div>
          </Card>
        </div>

        {/* Table */}
        <div style={{ overflowX: "auto", marginBottom: 20 }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead style={{ background: "#f6f6f6", textAlign: "left" }}>
              <tr>
                {["MSPC", "Rice", "Wheat", "Jaggery", "Dry Chilly", "Sugar", "Vitamin", "BG Dhall", "Overall Total", "Total Share"].map((header, idx) => (
                  <th key={idx} style={thStyle}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {stats.tableData.map((row, idx) => (
                <tr key={idx}>
                  {row.map((cell, jdx) => (
                    <td key={jdx} style={tdStyle}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ textAlign: "center" }}>
          <Button type="primary" style={{ background: "#19a459", padding: "0 30px", fontWeight: 600 }}>
            Submit For Approval
          </Button>
        </div>
      </Card>
    </div>



  );
};

export default PreviewScreen;
